// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReadMoreButton = require("../../components/buttons/ReadMoreButton.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MyDraftsWidgetDraftListItem = require("./MyDraftsWidgetDraftListItem.bs.js");
var MyDraftsWidgetDraftList_query_graphql = require("../../__generated__/MyDraftsWidgetDraftList_query_graphql.bs.js");
var MyDraftsWidgetDraftListPaginationQuery_graphql = require("../../__generated__/MyDraftsWidgetDraftListPaginationQuery_graphql.bs.js");

var getConnectionNodes = MyDraftsWidgetDraftList_query_graphql.Utils.getConnectionNodes;

var convertFragment = MyDraftsWidgetDraftList_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, MyDraftsWidgetDraftList_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = MyDraftsWidgetDraftListPaginationQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = MyDraftsWidgetDraftListPaginationQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(MyDraftsWidgetDraftList_query_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(MyDraftsWidgetDraftList_query_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

var QueryFragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

function MyDraftsWidgetDraftList$MyDraftsEmpty(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                "You have no draft posts available.",
                JsxRuntime.jsx("br", {}),
                JsxRuntime.jsx("br", {}),
                "Want to pre-market a listing on TAN? ",
                JsxRuntime.jsx(ButtonsV5.Link.make, {
                      href: "/properties/new",
                      className: "hover:underline",
                      children: "Broadcast a property now"
                    })
              ]
            });
}

var MyDraftsEmpty = {
  make: MyDraftsWidgetDraftList$MyDraftsEmpty
};

function MyDraftsWidgetDraftList(props) {
  var match = usePagination(props.query);
  var isLoadingNext = match.isLoadingNext;
  var hasNext = match.hasNext;
  var loadNext = match.loadNext;
  var data = match.data;
  var items = getConnectionNodes(data.draftsForCurrentAccountV5);
  var tmp;
  tmp = props.viewMoreMode === "ShowAllButton" ? (
      hasNext ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ReadMoreButton.make, {
                    href: "/my_drafts",
                    children: "View All"
                  }),
              className: "mt-4"
            }) : null
    ) : (
      hasNext ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                    onClick: (function (param) {
                        loadNext(30, undefined);
                      }),
                    disabled: isLoadingNext,
                    className: "w-full",
                    children: "See More Drafts"
                  }),
              className: "mt-4"
            }) : null
    );
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                items.length !== 0 ? JsxRuntime.jsx("div", {
                        children: items.map(function (item) {
                              var match = data.draftsForCurrentAccountV5;
                              return JsxRuntime.jsx(MyDraftsWidgetDraftListItem.make, {
                                          draft: item.fragmentRefs,
                                          listConnectionId: match !== undefined ? Caml_option.some(match.__id) : undefined
                                        }, item.nodeId);
                            }),
                        className: "flex flex-col border-b mb-6"
                      }) : JsxRuntime.jsx(MyDraftsWidgetDraftList$MyDraftsEmpty, {}),
                tmp,
                isLoadingNext ? JsxRuntime.jsx(Loader.make, {}) : null
              ]
            });
}

var make = MyDraftsWidgetDraftList;

exports.QueryFragment = QueryFragment;
exports.MyDraftsEmpty = MyDraftsEmpty;
exports.make = make;
/* Loader Not a pure module */
